export const MERCHANT_ONBOARDING_QUESTIONS = {

    riskMonitoring : "Merchant previously placed in Fraud/Risk Monitoring Program?",
    riskPayment: "Merchant previously terminated due to fraud/money laundering/high chargeback rates?",
    riskByCommission: "Merchant previously subject of complaint filed by Federal Trade Commission?"
}